import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Spin, Form} from 'antd';

import { Select, Input } from 'antd';
import { actions, asyncUpdate, asyncAdd, asyncGet } from './reducers';
import { formItemLayout, formatFormData } from './utils';
const FormItem = Form.Item;
const { TextArea } = Input;

class Edit extends React.Component {
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
        this.props.changeCurrentSelectId();
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                if(values.accountValues!=undefined){
                    values.accountValues = values.accountValues.split('\n');
                }
                if (this.props.item._id === undefined) {
                    await this.props.asyncAdd(formatFormData(values));
                } else {
                    values['_id'] = this.props.item._id;
                    await this.props.asyncUpdate(formatFormData(values));
                }
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.changeCurrentSelectId();
                this.props.asyncGet();
            } else {
                console.log(err);
            }
        });
    };

    render() {
        const { isModalShow, isLoading, item } = this.props;
        const { getFieldDecorator } = this.props.form;
        const form = (
            <Form>
                <Row>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="账号名称">
                            {getFieldDecorator('accountName', {
                                initialValue: item.accountName || '',
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入账号名称 ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="redisKey">
                            {getFieldDecorator('redisKey', {
                                initialValue: item.redisKey || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入redisKey',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="备注">
                            {getFieldDecorator('mark', {
                                initialValue: item.mark || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '输入备注',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="账号">
                            {getFieldDecorator('accountValues', {
                                initialValue: item.accountValues==undefined? '':item.accountValues.join('\n') ,
                                rules: [
                                    {
                                        required: false,
                                        message: '请填写',
                                    },
                                ],
                            })(
                                <TextArea rows={15} placeholder="请填写账号" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>

                </Row>
            </Form>
        );

        return (
            <span>
                <Modal
                    width={800}
                    title="修改"
                    visible={isModalShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isLoading}
                    maskClosable={true}
                    okText="确定"
                    cancelText="取消">
                    <Spin spinning={isLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    item: state.appAccount.list.reduce((a, b) => (b._id === state.appAccount.currentSelectId ? b : a), {}),
    isModalShow: state.appAccount.uiStatus.isUpdateShow,
    isLoading: state.appAccount.uiStatus.isLoading,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ isUpdateShow: false })),
    asyncUpdate: contents => dispatch(asyncUpdate(contents)),
    asyncAdd: contents => dispatch(asyncAdd(contents)),
    asyncGet: () => dispatch(asyncGet()),
    changeCurrentSelectId: () => dispatch(actions.changeCurrentSelectId('')),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Edit));



// WEBPACK FOOTER //
// ./pages/client/AppAccount/edit.js